import NoPermission from './no-permission/noPermission';
import PageNotFound from './page-not-found/pageNotFound';
import UnAuthorized from './un-authorized/unAuthorized';
import ChangePassword from './change-password/change-password';
import Teams from './my-teams/teams';
import Profile from './profile/profile';
import MyProjectCard from './my-project/my-projectCard';
import UserManagement from './user-management';
import { UserDashboard } from './user-management/dashboard';
import { Role } from './user-management/role/role';
import { Permission } from './user-management/permission/permission';
import { RolePermission } from './user-management/role-permission/rolePermission';
import { UserMaintenance } from './user-management/user/userMaintenance';
import { UserManager } from './user-management/user-manager/userManager';
import { Team } from './profile/team';
import MyProjectDetailCard from './my-project/my-project-detailCard';

const userManagement = new UserManagement();

export {
    NoPermission, PageNotFound, UnAuthorized, ChangePassword, Teams, Profile,
    UserDashboard, UserMaintenance, RolePermission, Permission, Role,
    userManagement, UserManager, Team, MyProjectCard, MyProjectDetailCard,
}